.linkComponent {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.button {
  position: relative;
  box-shadow: none;
  outline-offset: 0;
  border: 2px solid transparent;
  user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  padding: 0;
  border-radius: var(--btn-radius);
}
.button .content {
  text-shadow: none;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.button:not(.rounded) {
  --btn-radius: 4px;
}
.button.rounded {
  --btn-radius: var(--btn-rounded-radius);
}
.button:not([disabled]),
.button:not([aria-disabled="true"]) {
  cursor: pointer;
}
.button[disabled],
.button[aria-disabled="true"] {
  text-shadow: none;
  box-shadow: none;
  cursor: default;
}
.button:focus::after {
  content: "";
  position: absolute;
  top: -3px;
  left: -3px;
  bottom: -3px;
  right: -3px;
  border-radius: var(--btn-radius);
  box-shadow: 0 0 0 2px rgb(0, 147, 207, 0.62);
  z-index: 0;
}
.shrink {
  min-width: auto;
}
.block {
  width: 100%;
}
.callToAction {
  min-width: 200px;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: var(--btn-radius);
}
.tertiary {
  color: var(--color-tertiary-900);
  background: white;
  border: 2px solid var(--color-tertiary-900);
  padding: 0 16px;
}
.tertiary[aria-disabled="true"] {
  border: 2px solid var(--color-tertiary-400);
  color: var(--color-tertiary-400);
}
.tertiary:active,
.tertiary:focus {
  background-color: white;
  outline: 0;
}
.tertiary:hover:not([aria-disabled="true"]) {
  background: var(--color-gray-100);
  color: var(--color-tertiary-900);
}
.tertiary .loading {
  background: white;
  color: var(--color-tertiary-400);
}
.primary {
  color: var(--color-tertiary-900);
  background: var(--color-primary-400);
  border-color: var(--color-primary-400);
  padding: 0 16px;
}
.primary[aria-disabled="true"] {
  background: var(--color-primary-200);
  border-color: var(--color-primary-200);
}
.primary[aria-disabled="true"] .content {
  opacity: 0.5;
}
.primary:hover {
  color: var(--color-tertiary-900);
}
.primary:active,
.primary:focus {
  outline: 0;
}
.primary:active:not([aria-disabled="true"]),
.primary:focus:not([aria-disabled="true"]) {
  border-color: var(--color-primary-400);
  background-color: var(--color-primary-400);
  outline: 0;
}
.primary:hover:not([aria-disabled="true"]) {
  background-color: var(--color-primary-600);
  border-color: var(--color-primary-600);
}
.primary .loading {
  background: var(--color-primary-200);
}
.secondary {
  color: white;
  background: var(--color-tertiary-800);
  border-color: var(--color-tertiary-800);
  padding: 0 16px;
}
.secondary[aria-disabled="true"] {
  background: var(--color-tertiary-400);
  border-color: var(--color-tertiary-400);
}
.secondary:hover {
  color: white;
}
.secondary:active,
.secondary:focus {
  outline: 0;
}
.secondary:active:not([aria-disabled="true"]),
.secondary:focus:not([aria-disabled="true"]) {
  background-color: var(--color-tertiary-800);
  border-color: var(--color-tertiary-800);
}
.secondary:hover:not([aria-disabled="true"]) {
  background: var(--color-tertiary-900);
  border-color: var(--color-tertiary-900);
}
.secondary .loading {
  background: var(--color-tertiary-400);
}
.danger {
  color: white;
  background: var(--color-red-700);
  border-color: var(--color-red-700);
  padding: 0 16px;
}
.danger[aria-disabled="true"] {
  background: var(--color-red-350);
  border-color: var(--color-red-350);
}
.danger:hover {
  color: white;
}
.danger:active,
.danger:focus {
  outline: 0;
}
.danger:active:not([aria-disabled="true"]),
.danger:focus:not([aria-disabled="true"]) {
  background-color: var(--color-red-700);
  border-color: var(--color-red-700);
}
.danger:hover:not([aria-disabled="true"]) {
  background-color: var(--color-red-900);
  border-color: var(--color-red-900);
}
.danger .loading {
  background: var(--color-red-350);
}
.dangerTertiary {
  color: var(--color-red-700);
  background: white;
  border: 2px solid var(--color-red-700);
  padding: 0 16px;
}
.dangerTertiary[aria-disabled="true"] {
  border: 2px solid var(--color-red-350);
  color: var(--color-red-350);
}
.dangerTertiary:active,
.dangerTertiary:focus {
  background-color: white;
  outline: 0;
}
.dangerTertiary:hover:not([aria-disabled="true"]) {
  background: var(--color-gray-100);
  color: var(--color-red-900);
  border: 2px solid var(--color-red-900);
}
.dangerTertiary .loading {
  background: white;
  color: var(--color-red-350);
}
.text {
  color: var(--color-tertiary-900);
  background: transparent;
  border-color: transparent;
  padding: 0 16px;
}
.text[aria-disabled="true"] {
  color: var(--color-tertiary-400);
}
.text:focus {
  outline: 0;
}
.text:active:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
  outline: 0;
}
.text:hover:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
}
.text .loading {
  outline: 0;
}
.textOnlyLink {
  color: var(--color-tertiary-900);
  background: transparent;
  display: inline-block;
  height: auto;
  padding: 0;
  margin: 0;
  border: none;
}
.textOnlyLink[aria-disabled="true"] {
  color: var(--color-tertiary-400);
}
.textOnlyLink:focus {
  outline: 0;
}
.textOnlyLink:active:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
  outline: 0;
}
.textOnlyLink:hover:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
}
.textOnlyLink .loading {
  outline: 0;
}
.textOnlyLinkLight {
  background: transparent;
  display: inline-block;
  height: auto;
  padding: 0;
  margin: 0;
  border: none;
  text-decoration: underline;
  color: var(--color-tertiary-800);
  /* stylelint-disable-next-line no-descending-specificity */
}
.textOnlyLinkLight[aria-disabled="true"] {
  color: var(--color-tertiary-400);
}
.textOnlyLinkLight:focus {
  outline: 0;
}
.textOnlyLinkLight:active:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
  outline: 0;
}
.textOnlyLinkLight:hover:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
}
.textOnlyLinkLight .loading {
  outline: 0;
}
/* stylelint-disable-next-line no-descending-specificity */
.textOnlyLinkLight .content {
  font-weight: normal;
}
.textOnly {
  color: var(--color-tertiary-900);
  background: transparent;
  border: 0;
}
.textOnly[aria-disabled="true"] {
  color: var(--color-tertiary-400);
}
.textOnly:focus {
  outline: 0;
}
.textOnly:active:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
  outline: 0;
}
.textOnly:hover:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
}
.textOnly .loading {
  outline: 0;
}
.textOnlyLight {
  background: transparent;
  border: 0;
  color: var(--color-tertiary-800);
}
.textOnlyLight[aria-disabled="true"] {
  color: var(--color-tertiary-400);
}
.textOnlyLight:focus {
  outline: 0;
}
.textOnlyLight:active:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
  outline: 0;
}
.textOnlyLight:hover:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-secondary-900);
}
.textOnlyLight .loading {
  outline: 0;
}
/* stylelint-disable-next-line no-descending-specificity */
.textOnlyLight .content {
  font-weight: normal;
}
.dangerTextOnly {
  color: var(--color-red-700);
  background: transparent;
  border: 0;
}
.dangerTextOnly[aria-disabled="true"] {
  color: var(--color-red-350);
}
.dangerTextOnly:focus {
  outline: 0;
}
.dangerTextOnly:active:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-red-900);
  outline: 0;
}
.dangerTextOnly:hover:not([aria-disabled="true"]) {
  text-decoration: underline;
  color: var(--color-red-900);
}
.dangerTextOnly .loading {
  outline: 0;
}
.xtraSmall {
  --btn-rounded-radius: 24px;

  font-size: 0.875rem;
}
.xtraSmall:not(.shrink):not(.block):not(.callToAction) {
  min-width: 104px;
}
.xtraSmall:not(.textOnly):not(.dangerTextOnly):not(.textOnlyLink):not(.textOnlyLinkLight) {
  height: 32px;
}
.small {
  --btn-rounded-radius: 24px;

  font-size: 0.875rem;
}
.small:not(.shrink):not(.block):not(.callToAction) {
  min-width: 104px;
}
.small:not(.textOnly):not(.dangerTextOnly):not(.textOnlyLight):not(.textOnlyLink):not(
    .textOnlyLinkLight
  ) {
  height: 40px;
}
.middle {
  --btn-rounded-radius: 32px;

  font-size: 1rem;
}
.middle:not(.shrink):not(.block):not(.callToAction) {
  min-width: 200px;
}
.middle:not(.textOnly):not(.dangerTextOnly):not(.textOnlyLink):not(.textOnlyLinkLight) {
  height: 48px;
}
.large {
  --btn-rounded-radius: 48px;

  font-size: 1.125rem;
}
.large:not(.shrink):not(.block):not(.callToAction) {
  min-width: 200px;
}
.large:not(.textOnly):not(.dangerTextOnly):not(.textOnlyLink):not(.textOnlyLinkLight) {
  height: 56px;
}
.icon {
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  line-height: 1;
}
